<template>
  <div style="background-color:#F5F9FC">
    <div class="container">
      <div class="pd">
        <div class="header">
          <h3 class="text-center">
            Certificate
          </h3>
        </div>
        <div class="bg-img">
          <img class="fishes" src="../../assets/im/2795712 (1).svg" alt="" />

          <img class="fish" src="../../assets/im/ISA-ML (1).png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.bg-img {
  position: relative;
  left: 0;
  top: 0;
  margin: 250px 0;
}
.fishes {
  position: relative;
  top: 0;
  left: auto;
  width: 100%;
  max-height: 200px;
}
.fish {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  /* position: absolute;
      top: -130px;
      left: 350px; */
  width: 625px;
  max-height: 454px;
}

.pd {
  padding: 0 25px;
}
.header h3 {
  text-transform: uppercase;
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 7.2px;
  line-height: 24px;
  padding-top: 100px;

  color: #035bf4;
}

@media only screen and (max-width: 600px) {
  .bg-img {
    position: relative;
    left: 0;
    top: 0;
    margin: 100px 0;
    margin-top: 100px !important;
  }
  .fishes {
    position: relative;
    top: 0;
    left: auto;
    width: 100%;
    max-height: 200px;
  }
  .fish {
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    /* position: absolute;
      top: -130px;
      left: 350px; */
    width: 300px;
    max-height: 300px;
  }
  .header h3 {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 6.4px;
    line-height: 24px;
    padding-top: 45px;

    color: black;
  }
}
</style>
